import { render, staticRenderFns } from "./personal-form.vue?vue&type=template&id=3a8728f2&"
import script from "./personal-form.vue?vue&type=script&lang=js&"
export * from "./personal-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports